import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Layers } from 'lucide-react';
import { plottrackPath } from '../../utils/plottrackPath';
import './MigrationNotice.css';

/**
 * MigrationNotice — shown when opening a legacy structural workshop session
 * (workshop_structure / workshop_act / workshop_sequence / workshop_scene /
 * workshop_beat / workshop_chapter / workshop_skeleton / outline_section).
 *
 * PlotTrack is the writer-facing outline door now. Old workshop sessions
 * stay readable in the database and their outline sections remain the writer's
 * outline, but the working surface is PlotTrack. Passive by design: no
 * auto-creation, just directions to the grid.
 */
export default function MigrationNotice({ session, onBack }) {
  const navigate = useNavigate();
  const storyId = session?.story_id;

  return (
    <div className="migration-notice">
      <div className="migration-notice__card">
        <Layers size={28} aria-hidden="true" className="migration-notice__icon" />
        <h2>This workshop has a new home</h2>
        <p>
          Structure work now happens on <strong>Plot Grid</strong> — your
          threads and scenes on one grid. Everything you built here is still
          your outline and carries over.
        </p>
        <p className="migration-notice__how">
          To continue: open <strong>Plot Grid</strong> from the sidebar
          on this story.
        </p>
        <div className="migration-notice__actions">
          <button
            type="button"
            className="migration-notice__primary"
            onClick={() => navigate(plottrackPath(storyId))}
          >
            <Layers size={16} aria-hidden="true" /> Open Plot Grid
          </button>
          <button type="button" className="migration-notice__back" onClick={onBack}>
            <ArrowLeft size={16} aria-hidden="true" /> Back
          </button>
        </div>
      </div>
    </div>
  );
}
